export const formatCompanyName = (companyName: string) => {
  return companyName
    .trim()
    .toUpperCase()
    .replace(/[^\w\s-_]/g, '')
    .replace(/[\s-\/]/g, '_');
}

/** El onboarding intentó crear una compañía cuyo id ya existe: nunca se sobrescribe. */
export class CompanyNameTakenError extends Error {
  readonly code = 'onboarding/company-name-taken'

  constructor(readonly companyId: string) {
    super('onboarding/company-name-taken')
    this.name = 'CompanyNameTakenError'
  }
}
